import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import Input from '@/components/common/Input';
import PasswordInput from '@/components/common/PasswordInput';
import Button from '@/components/common/Button';
import SocialLoginButtons from '@/components/common/SocialLoginButtons';

export default function LoginPage() {
  const { signIn, signInWithGoogle, error, clearError, isLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    try {
      await signIn(email, password);
    } catch {
      // Error is set in the hook
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-semibold text-neutral-900">Sign In</h2>

      {error && (
        <div className="rounded-lg bg-error-50 p-3 text-sm text-error-700" role="alert">
          {error}
        </div>
      )}

      <SocialLoginButtons onGoogleClick={signInWithGoogle} label="signin" />

      <Input
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        required
        autoComplete="email"
      />

      <PasswordInput
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder=""
        required
        autoComplete="current-password"
      />

      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2 text-sm text-neutral-600">
          <input type="checkbox" className="rounded border-neutral-300 accent-primary-600" />
          Remember me
        </label>
        <Link to="/forgot-password" className="text-sm text-primary-600 hover:text-primary-700">
          Forgot password?
        </Link>
      </div>

      <Button type="submit" className="w-full" loading={isLoading}>
        Sign In
      </Button>

      <p className="text-center text-sm text-neutral-600">
        Don't have an account?{' '}
        <Link to="/signup" className="font-medium text-primary-600 hover:text-primary-700">
          Sign up
        </Link>
      </p>
    </form>
  );
}
